import { useCallback, useEffect, useState } from 'react';
import { assets, linkEditing } from '@yola/ws-sdk';

const { linkTypes } = linkEditing.constants;
const DEFAULT_PATH_VALUE = '/';

const useDownloadCustomPath = (initialLinkConfig = null, onCustomPathLoaded) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);

  const toggleCustomPathField = useCallback(() => {
    setIsVisible((visibilityState) => !visibilityState);
  }, []);

  const enableCustomPath = useCallback(() => {
    setIsDisabled(false);
  }, []);

  useEffect(() => {
    if (
      initialLinkConfig?.linkType !== linkTypes.DOWNLOAD ||
      !initialLinkConfig?.reference ||
      initialLinkConfig.reference.startsWith('#')
    ) {
      return () => {};
    }

    setIsLoading(true);

    let wasUnmount = false;

    assets.operations.getMediaLibraryAsset(initialLinkConfig.reference).then((assetData) => {
      if (!wasUnmount) {
        if (assetData) {
          onCustomPathLoaded(assetData.customPath || DEFAULT_PATH_VALUE);
          setIsVisible(!!assetData.customPath);
        }

        setIsLoading(false);
      }
    });

    return () => {
      wasUnmount = true;
    };
    // eslint-disable-next-line yola/react-hooks/exhaustive-deps
  }, []);

  return {
    state: {
      disabled: isDisabled,
      visible: isVisible,
      isLoading,
    },
    handlers: {
      toggleCustomPathField,
      enableCustomPath,
    },
  };
};

export default useDownloadCustomPath;
